import { Button, Col, Row, Typography, message } from 'antd';
import React, { useState } from 'react';
import BasicInfoEdit from './BasicInfoEdit';
import { countryList } from '../../../data/countryList';
import {
  updateTrainerInfo,
  uploadTrainerImage
} from '../../../services/trainerServices';
import Avatar from 'antd/lib/avatar/avatar';
import { beforeImageUpload } from '../../../utilities/imageUpload';

const { Text } = Typography;

function isEmptyPlaceholder(data) {
  return !!data ? data : 'N.A.';
}

function findCountryName(id) {
  return countryList.find((data) => data.id === id)?.name;
}

function BasicInfo({ basicInfo, updateTrainerLocalData }) {
  const [isBasicEditOpen, setIsBasicEditOpen] = useState(false);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode.'
  });

  const initialValues = {
    firstName: basicInfo.firstName,
    lastName: basicInfo.lastName,
    description: basicInfo.description,
    longDescription: basicInfo.longDescription,
    profileImage: basicInfo.profileImage,
    countryId: basicInfo.countryId,
    email: basicInfo.email,
    meetFacilitatorImg: basicInfo.meetFacilitatorImg
  };

  const firstNameInitial = basicInfo.firstName.substring(0, 1);

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Loading for request!' });
    let trainerData = {
      ...basicInfo,
      ...values
    };
    await updateTrainerInfo(basicInfo.trainerId, trainerData)
      .then((response) => {
        console.log('Updated Trainer: ', response);
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Succesful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  function toggleBasicEdit() {
    setIsBasicEditOpen((prev) => !prev);
  }

  const onImageUpload = async (e) => {
    const formData = new FormData();
    formData.append(
      'name',
      `${basicInfo.firstName} ${basicInfo.lastName}`
    );
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'avatar')
      .then((res) => {
        let trainerData = {
          ...basicInfo,
          profileImage: res.data.imageUrl
        };
        updateTrainerLocalData(trainerData);
        e.onSuccess();
        message.success(`${e.file.name} file uploaded successfully`);
      })
      .catch((err) => {
        e.onError();
        message.error(`${e.file.name} file upload failed.`);
      });
  };

  return (
    <div>
      <Row justify="space-between">
        <h2>Basic Info</h2>
        <Button onClick={toggleBasicEdit}>Edit</Button>
      </Row>
      <Row justify="space-between">
        <Col span={16}>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Trainer Id:</Col>
            <Col span={16}>
              <Text strong>{basicInfo.trainerId}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Is Active:</Col>
            <Col span={16}>
              <Text strong>{basicInfo.isActive.toString()}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>First Name:</Col>
            <Col span={16}>
              <Text strong>{isEmptyPlaceholder(basicInfo.firstName)}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Last Name:</Col>
            <Col span={16}>
              <Text strong>{isEmptyPlaceholder(basicInfo.lastName)}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Email:</Col>
            <Col span={16}>
              <Text strong>{isEmptyPlaceholder(basicInfo.email)}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Description:</Col>
            <Col span={16}>
              <Text strong>
                {isEmptyPlaceholder(basicInfo.description)}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          {basicInfo.profileImage ? (
            <Avatar
              shape="square"
              alt="profile"
              src={basicInfo.profileImage}
              size={140}
            />
          ) : (
            <Avatar
              shape="square"
              className="avatar-fallback"
              alt="profile"
              size={140}>
              {firstNameInitial}
            </Avatar>
          )}
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Long Description (Max 250 characters):</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(basicInfo.longDescription)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Profile Image:</Col>
        <Col span={16}>
          <Text strong>{isEmptyPlaceholder(basicInfo.profileImage)}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Meet Facilitator Image</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(
              basicInfo.meetFacilitatorImg?.desktopImgData?.src
            )}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Country:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(findCountryName(basicInfo.countryId))}
          </Text>
        </Col>
      </Row>
      <BasicInfoEdit
        initialValues={initialValues}
        isOpen={isBasicEditOpen}
        status={status}
        toggle={toggleBasicEdit}
        onSubmit={onSubmit}
        onImageUpload={onImageUpload}
        beforeImageUpload={beforeImageUpload}
      />
    </div>
  );
}

export default BasicInfo;
